import {createElement, forwardRef, HTMLAttributes} from 'react';

export const Div = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(
    (props, ref) => createElement('div', {...props, ref}),
);
Div.displayName = 'Div';

export const Span = forwardRef<
    HTMLSpanElement,
    HTMLAttributes<HTMLSpanElement>
>((props, ref) => createElement('span', {...props, ref}));
Span.displayName = 'Span';
